import { getPageUrl } from 'global/analyticsUtilities';
import { Events } from 'global/constants';

const coreMetricsAccountLinkEnd = () => {
	const dataNode = document.querySelector('[data-account-link-cm]');
	if (dataNode) {
		const data = {
			url: getPageUrl(),
			customerAccountNumber: dataNode.getAttribute('data-account-link-cm'),
		};
		window.od.events.publish(Events.ACCOUNT_LINK_CHECKOUT_END, data);
	}
};

export default coreMetricsAccountLinkEnd;
